export default {
    namespaced: true,
    state: {
      isShowBack: true
    },
    actions: {
      async setFlag ({ state, dispatch }, data) {
        state.isShowBack = data
      },
      
    }
  }
  